module.exports = __webpack_public_path__ + "img/integral_bg.73244fab.png";